import React from 'react';
import { Home } from '../components/Home';
import { Header } from '../components/Header';

export const HomePage = () => {
  return (
    <>
      <Header />
      <Home />
    </>
  );
};
